'use strict';
var ua = window.navigator.userAgent;
var msie = ua.indexOf("MSIE ");
var edge = ua.indexOf("Edge");
if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) { browser="ie"; }
else if (ua.indexOf("Edge") > 0 || ua.indexOf("edg") > 0 || ua.indexOf("opr") > 0 || ua.indexOf("safari") > 0) { browser="ie"; }

var menuButtons = Highcharts.getOptions().exporting.buttons.contextButton.menuItems.slice();
	/*Set options button*/
	menuButtons.splice(0,3);

var defaultUserConfig = { //by default, every option is switched off
		theme: 'basic',
		themeConf: {},
		cdata: {
			theme: 'basic',
			series: {}
		},
		menu: false,
		contextMenu: {
			image: true,
			alerts: false, /*Alert Setup True*/
		},
		dataSource: 'teapi',
		live: false,
		events: {
			innerBuildHandler: function innerBuildHandler() {},
			build: function build() {},
			click: function click() {},
			onOptionsChange: function onOptionsChange() {
				//notify outside that optins have been changed -> used on ueconomics
			}
		},
		hs: {
			crosshairs: {
				enabled: false
			},
			customTooltip: {
				enabled: false
			},
			inLabels: {
				enabled: false
			}
		}
	},
defaultHighstockOptions = { //#defaultConfigurations
	chart: {
		useHTML: true,
		marginTop: isMobile ? 40 : 40,
		marginRight: !isMobile? 63 : 58,
		animation: false,
		spacingTop: 0,
		spacingLeft: 0,
		spacingBottom: 0,
		events: {
			load: function () {
				let chart = this;
			},
			//render: renderChart,
			redraw : redrawFunction
		},
		resetZoomButton: {
			position: window.matchMedia("only screen and (max-width: 390px)").matches ? {x: -5, y: 5} : {x: -5, y: 25},
			theme: {
				fill: 'white',
				stroke: 'silver',
				r: 0,
			}
		},
		style: {
					fontFamily: "'Helvetica Neue',Helvetica,Arial,sans-serif",
		}
},
	credits: {
		enabled: false,
		href: 'https://tradingeconomics.com',
		text: 'TRADINGECONOMICS',
		position: {
			align: 'right',
			verticalAlign: 'bottom',
			x: -10,
			y: -10
		}
	},

	rangeSelector: { enabled: false },
	lang: {
		contextButtonTitle: 'Context Menu'
	},
	exporting: {
		useHTML:true,
		param: true,
		accessibility:{
			enabled: true
		},
		enabled: false,
		buttons: {
			cursor: 'pointer',
			contextButton: {
				cursor: 'pointer',
				//x: browser == 'ie' ? 10 : 7,
				//y: browser == 'ie' ? 16 : 8,
				width: 30,
				x: 2000, //Hide the default icon on loading
				menuItems: menuButtons,
				//symbol: 'url(https://cdn-icons-png.flaticon.com/512/61/61140.png)'
			},
		},
		filename: s ? s + "-" + date : "chart-" + date,
		chartOptions: {
			title: {
				text: 'source: tradingeconomics.com',
				style: {
					"font-size": regularFontSize,
					"color": isDarkMode == true ? "rgb(211,211,211)" : "#333"
				},
				align: 'right',
				verticalAlign: 'bottom',
			},
			subtitle:{
				style: {
					"font-size": regularFontSize,
					"color":"#333",
				},
				x: 14,
				y: 20,
				align: 'left',
				verticalAlign: 'top',
			}
		},
		width: 750,
		height: 520,
		sourceWidth: 750, /*EXPORTING SIZE*/
    sourceHeight: 520,
	fallbackToExportServer: false
	},
	accessibility:{
		enabled: false
	},
	navigation:{
		annotationsOptions: {
			shapeOptions: {
				stroke: isDarkMode ? 'red' : 'red',
				strokeWidth: 2
			},
				events: {
					contextmenu: function(e) {
						e.preventDefault();
						e.stopPropagation();
						// buildContextMenu(e.clientX,e.clientY, this)
						addContextMenuWithDots(this.options.langKey.toLowerCase() == 'label'? 'label' : 'line', this)
						return false;
					},
					dblclick: function(e) {
						e.preventDefault();
						if (this.userOptions) {
							if (this.userOptions.langKey) {
								if (this.userOptions.langKey.toLowerCase() == 'label') {
									addTextAnnotationPopup(this)
								}
							}
						}
					}
				}
		
		},
		bindingsClassName: 'tools-container',
		buttonOptions:{
			symbolSize: browser == 'ie' ? 18 : 14,
		},
		menuItemStyle: {
			"font-family": "'Helvetica Neue',Helvetica,Arial,sans-serif; !important",
			"font-size": "0.9em",
			"padding": "5px 8px",
		},
	},
	navigator: {
		enabled: false,
		height: 10,
		xAxis: {
			labels: {
				enabled: false
			}
		},
		handles: {}
	},
	scrollbar: {
		enabled: false,
		height: 8,
		barBackgroundColor: '#DDDDDD',
		barBorderRadius: 6,
		barBorderWidth: 0,
		buttonBackgroundColor: '#DDDDDD',
		buttonBorderWidth: 0,
		buttonBorderRadius: 5,
		trackBackgroundColor: 'none',
		trackBorderWidth: 1,
		trackBorderRadius: 8,
		trackBorderColor: '#EFEFEF'
	},
	tooltip: {
		enabled: true,
		crosshairs: false,
		shared: true,
		formatter: function formatter() {
			if (this.point) {
				// return this.point.text
			}
			return false;
		},
		positioner: function (labelWidth, labelHeight, point) {
			let tooltipCoord = {x: point.plotX - labelWidth/2, y: point.plotY - labelHeight/2 - 16}
			if (point.plotY < labelHeight) {
				tooltipCoord.y = point.plotY + labelHeight/2 + 20;
			}
			if (point.plotX > _th.chart.plotSizeX - labelWidth) {
				tooltipCoord.x = _th.chart.plotSizeX -labelWidth
			}
			if (point.plotX < labelWidth) {
				tooltipCoord.x = _th.chart.plotLeft
			}
			return tooltipCoord
		}
	},
	xAxis: [{}],
	yAxis: [
		{
			id: 'y_axis_main',
			offset: 1,
			zIndex: 9999,
			reversed: false,
			labels: {
				align: 'left',
				x: 7,
				y: 4.5,
				formatter: function formatter() {
					var decimals = 0
					if (this.value == null || this.value == 'null') {
						return '';
					}
					if(!Number.isInteger(this.value) && this.value < 10){
						if((this.value > 0 && this.value < 0.0010) || (this.value < 0 && this.value > -0.0010))
							{
								decimals = 5
								if(this.value.toFixed(decimals).toString().slice(-1) == 0){
									decimals = 4
								}

							}else{
								decimals = 4
								if(this.value.toFixed(decimals).toString().slice(-1) == 0){
									decimals = 3
								}
							}
					}else if(!Number.isInteger(this.value) && this.value > 10 && this.value < 1000){
						decimals = 2
					}

					
					if(decimals > 4){
						isToChangeMarginsY = true;
					}

					for(let axis in this.chart.series){
						if(this.chart.series[axis].data.length > 0 && this.chart.series[axis].options.yAxis == "y_axis_main"){
							if (this.chart.series[axis].options.compare == 'percent') {
								return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '%</span>';
							}else if(this.chart.series[axis].options.compare == 'value'){
								if(decimals >= 5){
									return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '</span>';
								}else{
									return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '</span>';
								}
							}
							else{
								this.chart.series[0].options.compare
							}
						}
					}
					if(decimals >= 5 || this.value > 99999 || this.value <= 0.0009){
						return '<span>' + this.value.toFixed(decimals) + '</span>';
				} else {
						return this.value.toFixed(decimals);
				}
				},
				style: {
					'font-size': regularFontSize,
					'color': 'unset'
				}
			},
			title: { text: '' },
			lineWidth: 1,
			lineColor: '#E6E6E6',
			gridLineColor: '#E7E7E7',
			opposite: true,
			showFirstLabel: false,
			tickWidth: 1,
			tickLength: 5,
			tickColor: "#E7E7E7",
			minPadding: 0.05,
			maxPadding: 0.15,
			tickPixelInterval: 60,
		},{
			id: 'yaxis_n',
			reversed: false,
			labels: {
				enabled: false
			},
			tickPixelInterval: 60
		},{
			id: 'y_axis_2',
			reversed: false,
			offset: 1,
			labels: {
				align: 'right',
				x: -7,
				y: 4,
				formatter: function formatter() {
					var decimals = 0
					if (this.value == null || this.value == 'null') {
						return '';
					}
					if(!Number.isInteger(this.value) && this.value < 10){
						if((this.value > 0 && this.value < 0.0010) || (this.value < 0 && this.value > -0.0010))
							{
								decimals = 5
								if(this.value.toFixed(decimals).toString().slice(-1) == 0){
									decimals = 4
								}
							}else{
								decimals = 4
								if(this.value.toFixed(decimals).toString().slice(-1) == 0){
									decimals = 3
								}
							}
					}else if(!Number.isInteger(this.value) && this.value > 10 && this.value < 1000){
						decimals = 2
					}

					if(decimals > 4){
						isToChangeMarginsY2 = true;
					}

					for(let axis in this.chart.series){
						if(this.chart.series[axis].data.length > 0 && this.chart.series[axis].options.yAxis == "y_axis_2"){
							if (this.chart.series[axis].options.compare == 'percent') {
								return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '%</span>';
							}else if(this.chart.series[axis].options.compare == 'value'){
								if(decimals >= 5){
									return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '</span>';
								}else{
									return '<span>' + (this.value > 0 ? '+' : '') + this.value.toFixed(decimals) + '</span>';
								}
							}
							else{
								this.chart.series[0].options.compare
							}
						}
					}

					if(decimals >= 5 || this.value > 9999){
						return '<span>' + this.value.toFixed(decimals) + '</span>';
				} else {
						return this.value.toFixed(decimals);
				}
				},
				style: {
					'font-size': regularFontSize,
					'color': 'unset'
				}
			},
			title: { text: '' },
			lineWidth: 1,
			gridLineWidth: 1,
			gridLineColor: '#E7E7E7',
			lineColor: null,
			opposite: false,
			showFirstLabel: false,
			tickWidth: 1,
			tickLength: 5,
			tickColor: "#E7E7E7",
			minPadding: 0.05,
			maxPadding: 0.15,
			tickPixelInterval: 60
		}
	],
	stockTools: {
		gui: {
			enabled: true
		}
	},
	plotOptions: {
		series: {
			states: {
			  inactive: {
				opacity: 1
			  }
			}
		  },
		area: {
			marker: {
				enabled: false,
				radius: 2,
				symbol: 'circle',
				lineColor: null,
				lineWidth: 0
			},
			states: {
				hover: {
					enabled: true,
					lineWidthPlus: 0,
					halo: false,
					marker: {
						enabled: true
					}
				}
			}
		},
		line: {
			lineWidth: 2,
			marker: {
				enabled: false,
				radius: 2,
				symbol: 'circle',
				lineColor: null,
				lineWidth: 0
			},
			states: {
				hover: {
					enabled: true,
					lineWidthPlus: 0,
					halo: false,
					marker: {
						enabled: true
					}
				}
			}
		},
		candlestick: {
			groupPadding: 0,
			lineWidth: 1,
			maxPointWidth: 100,
			pointPadding: 0.01,
		},
		ohlc: {
			states: {
				hover: {
					enabled: false
				}
			}
		}
	},

	crosshairs: {
		enabled: true,
		labels: {
			style: {
				'background-color': '#4B525E',
				'color': '#FFFFFF',
				'padding': '5px 0px 4px 0px',
				'font-size': regularFontSize,
			}
		}
	},
	myAnnotations: {
		enabled: false
	},
	inLabels: {
		enabled: false
	}
},
    THEMES = {
		basic: {
			colors: ["#4885ed", "#4CAF50", "#FF5722", "#504F4F", "#71BCA5", "#C67444", "#059BAF", "#C86D80", "#C9C9C9"],
			plotOptions: {
				series: {
					dataLabels: {
						'color': '#1A1A1A'
					},
					marker: {
						lineColor: '#333'
					}
				},
				boxplot: {
					color: '#27AE60',
					fillColor: '#27AE60'
				},
				candlestick: {
					lineColor: '#EF5350',
					color: '#EF5350',
					fillColor: 'rgb(215,85,66)',
					upColor: '#28A69A',
					upLineColor: '#28A69A',
				},
				ohlc: {
					lineColor: '#EF5350',
					upColor: '#28A69A',
				},
				errorbar: {
					color: '#27AE60',
					fillColor: '#27AE60'
				}
			}
		}
	},
    MINUTE = 1000 * 60,
    HOUR = MINUTE * 60,
    DAY = HOUR * 24,
    YEAR = DAY * 365;

		var STOCK_INTERVALS = {
			'1m': {
				id: '1m',
				span: '6h',
				text: '1 Minute',
				intraday: true
			},
			'5m': {
				id: '5m',
				span: '1w',
				text: '5 Minutes',
				intraday: true
			},
			'15m': {
				id: '15m',
				span: '1m',
				text: '15 Minutes',
				intraday: true
			},
			'1h': {
				id: '1h',
				span: '6m',
				text: '1 Hour',
				intraday: true,
				display: '1H'
			},
			'1d': {
				id: '1d',
				span: '1y',
				text: '1 Day',
				intraday: false,
				display: '1D'
			},
			'1w': {
				id: '1w',
				span: '5y',
				text: '1 Week',
				intraday: false,
				display: '1W'
			},
			'1month': {
				id: '1month',
				span: '25y',
				text: '1 Month',
				intraday: false,
				display: '1M'
			}
		};
		
    var INTERVALS = {
	'1m': {
		id: '1m',
		span: '6h',
		text: '1 Minute',
		intraday: true
	},
	'5m': {
		id: '5m',
		span: '1d',
		text: '5 Minutes',
		intraday: true
	},
	/*'10m': {
		id: '10m',
		span: '1d',
		text: '10 Minutes',
		intraday: true
	},*/
	'15m': {
		id: '15m',
		span: '1w',
		text: '15 Minutes',
		intraday: true
	},
	/*'30m': {
		id: '30m',
		span: '1w',
		text: '30 Minutes',
		intraday: true
	},*/
	'1h': {
		id: '1h',
		span: '1m',
		text: '1 Hour',
		intraday: true,
		display: '1H'
	},
	/*'4h': {
		id: '4h',
		span: '3m',
		text: '4 Hours',
		intraday: true,
		display: '4H'
	},*/
	'1d': {
		id: '1d',
		span: '1y',
		text: '1 Day',
		intraday: false,
		display: '1D'
	},
	'1w': {
		id: '1w',
		span: '5y',
		text: '1 Week',
		intraday: false,
		display: '1W'
	},
	'1month': {
		id: '1month',
		span: '25y',
		text: '1 Month',
		intraday: false,
		display: '1M'
	}
};

var   SPANS = {
	'1d': {
		val: DAY,
		agr: '5m',
		n_days: 1,
		intervals: ['1m', '5m', '15m']
	},
	'5d': {
		val: DAY * 5,
		agr: '10m',
		n_days: 10
	},
	'1w': {
		val: DAY * 7,
		agr: '10m',
		n_days: 14,
		intervals: ['10m', '15m', '30m']
	},
	'1m': {
		val: DAY * 30,
		agr: '1h',
		n_months: 6,
		intervals: ['30m', '1h', '6h']
	},
	'3m': {
		val: DAY * 30 * 3,
		agr: '1d',
		n_years: 1,
		intervals: ['1d']
	},
	'6m': {
		val: DAY * 30,
		agr: '1d',
		n_years: 1,
		intervals: ['1d']
	},
	'1y': {
		val: YEAR,
		agr: '1d',
		n_years: 3,
		intervals: ['1d']
	},
	'5y': {
		val: YEAR * 5,
		agr: '1month',
		n_years: 5,
		intervals: ['1month']
	},
	'10y': {
		val: YEAR * 10,
		agr: '1month',
		n_years: 20
	},
	'20y': {
		val: YEAR * 20,
		agr: '1month',
		n_years: 20
	}
},
SPAN_PICKER = {
	intraday: [{
		text: '1D',
		fullText:'1 Day',
		span: DAY,
		val: '1D'
	}, {
		text: '1W',
		fullText:'1 Week',
		span: DAY * 7,
		val: '1W'
	}, {
		text: '1M',
		fullText:'1 Month',
		span: DAY * 30,
		val: '1M'
	}, /*{
		text: '3M',
		fullText:'3 Month',
		span: DAY * 30,
		val: '3M'
	},*/ {
		text: '6M',
		fullText:'6 Month',
		span: DAY * 30,
		val: '6M'
	}, {
		text: '1Y',
		fullText:'1 Year',
		span: YEAR,
		val: '1Y',
	}, {
		text: '5Y',
		fullText:'5 Year',
		span: YEAR,
		val: '5Y',
	}, {
		text: '10Y',
		fullText:'10 Year',
		span: YEAR * 10,
		val: '10y'
	}, {
		text: '25Y',
		fullText:'25 Year',
		span: YEAR * 25,
		val: '25y'
	}, {
		text: '50Y',
		fullText:'50 Year',
		span: YEAR * 50,
		val: '50y'
	}, {
		text: 'All',
		fullText:'All',
		span: YEAR * 100,
		val: 'max'
	}],

	rest: [{
		text: '1Y',
		fullText:'1 Year',
		span: YEAR,
		val: '1y'
	}, {
		text: '5Y',
		fullText:'5 Year',
		span: YEAR * 5,
		val: '5y'
	}, {
		text: '10Y',
		fullText:'10 Year',
		span: YEAR * 10,
		val: '10y'
	}, {
		text: '25Y',
		fullText:'25 Year',
		span: YEAR * 25,
		val: '25y'
	}, {
		text: '50Y',
		fullText:'50 Year',
		span: YEAR * 50,
		val: '50y'
	}, {
		text: 'All',
		fullText:'All',
		span: YEAR * 100,
		val: 'max'
	}]
},
    TREND_LINE = 'tl',
    HORIZONTAL_LINE = 'hl',
    CURSOR = 'cursor',
    ERROR = true,
    CR_RATINGS = {
	'values': [105, 100, 95, 90, 85, 80, 75, 70, 65, 60, 55, 50, 45, 40, 35, 30, 25, 20, 15, 10, 8, 5, 0, -5],
	'moodys': ["", "Aaa", "Aa1", "Aa2", "Aa3", "A1", "A2", "A3", "Baa1", "Baa2", "Baa3", "Ba1", "Ba2", "Ba3", "B1", "B2", "B3", "Caa1", "Caa2", "Caa3", "Ca", "C", "/", ""],
	'fitch': ["", "AAA", "AA+", "AA", "AA-", "A+", "A", "A-", "BBB+", "BBB", "BBB-", "BB+", "BB", "BB-", "B+", "B", "B-", "CCC", "", "", "", "", "DDD", ""],
	'sp': ["", "AAA", "AA+", "AA", "AA-", "A+", "A", "A-", "BBB+", "BBB", "BBB-", "BB+", "BB", "BB-", "B+", "B", "B-", "CCC+", "CCC", "CCC-", "CC", "C", "D", ""]
};
if (isMobile) {
	SPAN_PICKER.rest.unshift({
		text: '6M',
		fullText:'6 Month',
		span: DAY * 30,
		val: '6m'
	})
}